<template>
  <Dropdown
    v-model="model"
    :class="{
      'rounded-[6px]': !props.isNav,
      'rounded-none': props.isNav,
      'group -ml-px w-auto border-0 !bg-[--color-brand-forrest-green-05] !shadow-none ': !props.noStyle,
    }"
    :options="props.countries"
    :pt-options="{ mergeProps: true }"
    :pt="{
      root: {
        class: {
          'hover:text-[--v3-theme-highlighttextcolor]': !props.noStyle,
        },
      },
      wrapper: {
        class: {
          'frs-hide-scroll hidden md:block !max-h-[80vh]': !props.noStyle,
        },
      },
      input: {
        class: {
          'group-hover:text-[--v3-theme-highlighttextcolor]': !props.noStyle,
        },
      },
      trigger: {
        class: {
          'w-[28px] md:w-control group-hover:text-[--v3-theme-highlighttextcolor]': !props.noStyle,
        }
      },
    }"
    option-label="label"
    append-to="self"
    :loading="loading"
    @click="handleClick"
  >
    <template #value="slotProps">
      <div class="flex items-center gap-0 md:gap-[5px]">
        <Icon
          class="hidden md:block"
          :name="slotProps.value"
          :width="17"
          :height="17"
        />
        <span>{{ getCountryShortName(slotProps.value) }}</span>
      </div>
    </template>
    <template #option="slotProps">
      <div class="flex h-control items-center gap-[5px] p-0">
        <Icon :name="slotProps.option" :width="17" :height="17" />
        <span>{{ getCountryShortName(slotProps.option) }}</span>
      </div>
    </template>
  </Dropdown>
</template>

<script setup lang="ts">
import { useQuery } from '@tanstack/vue-query';
import Dropdown from 'primevue/dropdown';
import { watch } from 'vue';

import Icon from '@/common/components/atoms/Icon';
import { useMobile } from '@/common/composables/application';
import { getCountryShortName } from '@/helpers/country';
import { storage } from '@/helpers/local-storage';
import { userPreferenceQueryOptions, useUserPreferenceUpdateMutation } from '@/queries/user-preference';
import type { CountryCode } from '@/types/country';

const model = defineModel<CountryCode>();

const props = withDefaults(
  defineProps<{
    countries: Array<CountryCode>;
    isNav?: boolean;
    loading?: boolean;
    noStyle?: boolean;
  }>(),
  {
    isNav: true,
    loading: false,
    noStyle: false,
  },
);

const emit = defineEmits<{
  onShowCountries: [];
}>();

const { data: selectedCountryPreference } = useQuery(userPreferenceQueryOptions<string>('searchCountry'));

const {
  mutate: mutateSearchCountryPreferenceUpdate,
} = useUserPreferenceUpdateMutation('searchCountry');

const { isMobile } = useMobile();

const handleClick = () => {
  mutateSearchCountryPreferenceUpdate(model.value);
  if (isMobile.value) {
    emit('onShowCountries');
  }
};

watch(selectedCountryPreference, (value) => {
  if(value) {
    storage.set<string>('searchCountry', value);
  }
});
</script>
